import Typography from "@mui/material/Typography"

import Row from "../../../../common/components/Row"

export default function IconValue({ Icon, value }) {
  return (
    <Row
      sx={{
        alignItems: "center",
      }}
    >
      <Icon />
      <Typography variant="body1" sx={{ ml: 1 }}>
        {value}
      </Typography>
    </Row>
  )
}
